import { Controller } from '@hotwired/stimulus'

// Shows/hides an element when custom events are dispatched from other controllers
// Usage:
//   <div data-controller="show-element-on-event"
//        data-action="custom-event:dispatched->show-element-on-event#show">
//     This will be shown when the event is received
//   </div>
//
// From another controller, dispatch the event:
//   this.dispatch("dispatched", { prefix: "custom-event" })

export default class extends Controller {
    show() {
        this.element.classList.remove('d-none')
    }

    hide() {
        this.element.classList.add('d-none')
    }

    toggle() {
        this.element.classList.toggle('d-none')
    }
}
